import { useState, useEffect, useCallback } from 'react'

// #8 (Bloque F): expone un botón persistente de "Instalar app" en vez de
// depender solo del banner nativo del navegador (que aparece una sola vez).
// beforeinstallprompt no existe en iOS Safari — ahí `disponible` queda
// siempre en false y el botón que lo usa simplemente no se muestra,
// comportamiento esperado (no hay prompt de instalación nativo posible ahí).
export function usePwaInstall() {
  const [evento, setEvento] = useState(null)

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault()
      setEvento(e)
    }
    window.addEventListener('beforeinstallprompt', handler)
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  const instalar = useCallback(async () => {
    if (!evento) return
    await evento.prompt()
    setEvento(null)
  }, [evento])

  return { disponible: !!evento, instalar }
}
